/**
 * Header Navigation Component
 * Handles dropdown menu interactions and smooth scrolling
 */

import { SELECTORS } from '../utils/constants.js';

export class HeaderNav {
  constructor(container) {
    this.container = container;
    this.dropdownButton = container.querySelector(SELECTORS.headerNavDropdownButton);
    this.dropdownMenu = container.querySelector(SELECTORS.headerNavDropdownMenu);
    this.isOpen = false;

    this.init();
  }

  init() {
    if (!this.dropdownButton || !this.dropdownMenu) {
      console.warn('HeaderNav: Required elements not found');
      return;
    }

    this.bindEvents();
    console.log('HeaderNav initialized');
  }

  bindEvents() {
    // Toggle dropdown on button click
    this.dropdownButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.toggleDropdown();
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.container.contains(e.target)) {
        this.closeDropdown();
      }
    });

    // Close dropdown when pressing Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeDropdown();
      }
    });

    // Close dropdown when clicking on a dropdown link
    const dropdownLinks = this.dropdownMenu.querySelectorAll('a');
    dropdownLinks.forEach(link => {
      link.addEventListener('click', () => {
        this.closeDropdown();
      });
    });

    // Note: Smooth scrolling for anchor links is now handled by
    // the centralized anchor scroll system in utils/anchorScroll.js
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.dropdownMenu.classList.add('active');
    this.dropdownButton.setAttribute('aria-expanded', 'true');
    this.isOpen = true;
  }

  closeDropdown() {
    this.dropdownMenu.classList.remove('active');
    this.dropdownButton.setAttribute('aria-expanded', 'false');
    this.isOpen = false;
  }

  destroy() {
    // Clean up event listeners if needed
    this.closeDropdown();
  }
}

/**
 * Initialize header navigation
 */
export function initHeaderNav() {
  const dropdown = document.querySelector(SELECTORS.headerNavDropdown);

  if (dropdown) {
    return new HeaderNav(dropdown);
  }

  return null;
}
